import { esMarcaPersonalPalettes } from "../../../../Posts/05-tematicas/09-marca-personal/personalBrandPalettes.js";
import * as React from 'react';
export default {
  esMarcaPersonalPalettes,
  React
};